import { z } from "zod";

export const negotiationCounterSchema = z.object({
  negotiation_products_attributes: z.array(
    z.object({
      id: z.string(),
      desired_action: z.enum(['accept', 'reject', 'counter']),
      value: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
      counter_observation: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
      reject_observation: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
    }),
  ),
});

export type NegotiationCounterValidationSchema = z.infer<typeof negotiationCounterSchema>;
